import React, { useEffect } from 'react';
import { CreditCheckResult, CreditField } from 'modules/cm/Credit/Credit';
import { FormProvider, useForm } from 'react-hook-form';
import { createCreditCheckResult, FieldsLabels, Form } from './Credit';
import { TextInput, FormInputWrapper, NumericInput, DateInput } from 'form/infrastructure/reactHookForm';
import styled from 'styled-components';

interface Props {
  checkResult?: CreditCheckResult;
}

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 24px;

  div {
    flex: 1;
  }
`;

const CreditForm: React.FC<Props> = ({ checkResult }) => {
  const methods = useForm<Form>({
    defaultValues: checkResult || createCreditCheckResult(),
  });

  useEffect(() => {
    methods.reset(checkResult);
  }, [checkResult, methods]);

  return (
    <FormProvider<Form> {...methods}>
      <form>
        <StyledContainer>
          <FormInputWrapper title={FieldsLabels.ReferenceNumber} name={CreditField.ReferenceNumber}>
            <TextInput readOnly />
          </FormInputWrapper>
          <FormInputWrapper title={FieldsLabels.CreditScore} name={CreditField.CreditScore}>
            <NumericInput readOnly />
          </FormInputWrapper>
          <FormInputWrapper title={FieldsLabels.DateOfSearch} name={CreditField.DateOfSearch}>
            <DateInput readOnly />
          </FormInputWrapper>
        </StyledContainer>
      </form>
    </FormProvider>
  );
};
export default CreditForm;
